import React, { Fragment } from "react";
import { useField } from "formik";

type TextInputProps = {
    id: string;
    placeholder: string;
    disabled?:boolean;
};
export const TextInput = ({ id, placeholder, disabled=false , ...props }: TextInputProps) => {
    const [field, meta] = useField(id);
    return (
        <Fragment>
            <div className="mt-1 relative shadow-sm w-full">
                <input
                    id={id}
                    className={`${(meta.error)?'form-input rounded-none block w-full pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red sm:text-sm sm:leading-5':`form-input rounded-none block w-full sm:text-sm sm:leading-5 ${(disabled)?'bg-gray-200':''}`}`}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...field}
                    {...props}
                />
                {(meta.touched && meta.error)? <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                    <svg
                        className="h-5 w-5 text-red-500"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>:''}

            </div>
            {(meta.touched && meta.error)?<p className="mt-2 text-sm text-red-600" id="email-error">{meta.error}</p>:''}

        </Fragment>
    );
};